import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import { Case, If, OtherWise } from "~/common/components/If";
import Detail from "~/pages/vcInfo/VcInformation/Detail";
import Edit from "~/pages/vcInfo/VcInformation/Edit";
import { useLocation } from "react-router";

const VcInformation = () => {
	const [page, setPage] = useState("detail");
	const location = useLocation();
	const query = new URLSearchParams(location.search);
	const edit = query.get('edit');

	useEffect(() => {
		edit === 'true' && setPage('edit')
	}, [])

	return (
		<NavbarAndSidebarLayout menu={["vcInfo", "info"]} type={"main"}>
			<If condition={page} {...{ setPage }}>
				<Case condition="detail">
					<Detail />
				</Case>
				<OtherWise>
					<Edit />
				</OtherWise>
			</If>

		</NavbarAndSidebarLayout>
	);
};

export default VcInformation;
